import { render, staticRenderFns } from "./OVDetail.vue?vue&type=template&id=52188ecb&scoped=true&lang=pug"
import script from "./OVDetail.vue?vue&type=script&lang=js"
export * from "./OVDetail.vue?vue&type=script&lang=js"
import style0 from "./OVDetail.vue?vue&type=style&index=0&id=52188ecb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52188ecb",
  null
  
)

export default component.exports